import '../ListingSources/ListingSources.scss';
import './TrueOwners.scss';
import Component from './TrueOwners.js';
export default Component;
